import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useLang } from '../i18n/LangContext';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const navLinks = [
    { id: 'about', label: t('nav.about'), href: '#about' },
    { id: 'divisions', label: t('nav.divisions'), href: '#divisions' },
    { id: 'projects', label: t('nav.experience'), href: '#projects' },
    { id: 'industries', label: t('nav.industries'), href: '#industries' },
    { id: 'workforce', label: t('nav.workforce'), href: '#workforce' },
    { id: 'gallery', label: t('nav.gallery'), href: '#gallery' },
    { id: 'contact', label: t('nav.contact'), href: '#contact' },
  ];

  const onAnchor = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="relative border-t border-[#27272A] bg-[#0A0A0B] overflow-hidden">
      {/* Background watermark */}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-10 left-0 right-0 text-center select-none">
        <span className="font-display tracking-tighter text-[18vw] leading-none text-[#101013]">ALPHA&nbsp;7</span>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-5">
            <Logo size={44} />
            <div className="mt-5 leading-tight">
              <div className="font-display text-2xl tracking-tight text-[#F5F5F2]">
                ALPHA <span className="text-[#C8102E]">7</span>
              </div>
              <div className="mt-1 font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA]">
                Soluciones y Proyectos
              </div>
            </div>
            <p className="mt-6 max-w-sm text-[#A1A1AA] leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="mt-6 inline-flex items-center gap-3 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F5F5F2]/80">
              <span className="w-1.5 h-1.5 bg-[#C8102E]" />
              {t('hero.ticker')}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-5">
              {t('footer.nav_label')}
            </div>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a
                    href={l.href}
                    onClick={(e) => onAnchor(e, l.href)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-[#F5F5F2] hover:text-[#C8102E] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-5">
              {t('footer.contact_label')}
            </div>
            <ul className="space-y-3 text-[#F5F5F2]">
              <li className="text-sm leading-relaxed">{t('contact.director_name')}</li>
              <li>
                <a className="hover:text-[#C8102E] transition-colors break-all" href="mailto:direccion@alpha7.com.mx" data-testid="footer-email-link">
                  direccion@alpha7.com.mx
                </a>
              </li>
              <li className="text-sm text-[#A1A1AA]">{t('contact.office_value')}</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A1A1AA] mb-5">
              {t('footer.legal_label')}
            </div>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link" className="text-[#F5F5F2] hover:text-[#C8102E] transition-colors">
                  {t('footer.privacy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#27272A] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#A1A1AA] font-mono tracking-wider uppercase">
          <span>© 2017–{year} ALPHA 7 Soluciones y Proyectos. {t('footer.rights')}</span>
          <span>MX — North America Operations</span>
        </div>
      </div>
    </footer>
  );
}
